import {
  ToothAIcon, ToothBIcon, ToothCIcon, ToothDIcon,
  ToothEIcon, ToothFIcon, ToothGIcon, ToothHIcon,
  ToothIIcon, ToothJIcon, ToothKIcon, ToothLIcon,
  ToothMIcon, ToothNIcon, ToothOIcon, ToothPIcon,
  ToothQIcon, ToothRIcon, ToothSIcon, ToothTIcon,
} from '@shared/icons';

export const upperPrimary = [
  {
    value: 'Tooth #55',
    icon: <ToothAIcon width="18" height="27" />,
    label: '55',
  },
  {
    value: 'Tooth #54',
    icon: <ToothBIcon width="18" height="28" />,
    label: '54',
  },
  {
    value: 'Tooth #53',
    icon: <ToothCIcon width="10" height="39" />,
    label: '53',
  },
  {
    value: 'Tooth #52',
    icon: <ToothDIcon width="9" height="37" />,
    label: '52',
  },
  {
    value: 'Tooth #51',
    icon: <ToothEIcon width="11" height="39" />,
    label: '51',
  },
  {
    value: 'Tooth #61',
    icon: <ToothFIcon width="11" height="39" />,
    label: '61',
  },
  {
    value: 'Tooth #62',
    icon: <ToothGIcon width="9" height="37" />,
    label: '62',
  },
  {
    value: 'Tooth #63',
    icon: <ToothHIcon width="10" height="39" />,
    label: '63',
  },
  {
    value: 'Tooth #64',
    icon: <ToothIIcon width="18" height="28" />,
    label: '64',
  },
  {
    value: 'Tooth #65',
    icon: <ToothJIcon width="18" height="27" />,
    label: '65',
  },
];

export const lowerPrimary = [
  {
    value: 'Tooth #85',
    icon: <ToothTIcon width="18" height="31" />,
    label: '85',
  },
  {
    value: 'Tooth #84',
    icon: <ToothSIcon width="18" height="32" />,
    label: '84',
  },
  {
    value: 'Tooth #83',
    icon: <ToothRIcon width="10" height="37" />,
    label: '83',
  },
  {
    value: 'Tooth #82',
    icon: <ToothQIcon width="8" height="34" />,
    label: '82',
  },
  {
    value: 'Tooth #81',
    icon: <ToothPIcon width="8" height="34" />,
    label: '81',
  },
  {
    value: 'Tooth #71',
    icon: <ToothOIcon width="8" height="34" />,
    label: '71',
  },
  {
    value: 'Tooth #72',
    icon: <ToothNIcon width="8" height="34" />,
    label: '72',
  },
  {
    value: 'Tooth #73',
    icon: <ToothMIcon width="10" height="37" />,
    label: '73',
  },
  {
    value: 'Tooth #74',
    icon: <ToothLIcon width="18" height="32" />,
    label: '74',
  },
  {
    value: 'Tooth #75',
    icon: <ToothKIcon width="18" height="31" />,
    label: '75',
  },
];
